// @ts-nocheck
import { IUserColorModel } from '../models/UserColorModel';

export class ColorScheme {
  constructor(
    public backgroundColor: string,
    public borderColor: string
  ) {}
}

export class UserColor {
  public static userColorList: Array<ColorScheme> = [
    new ColorScheme('#D22000', '#A41800'),
    new ColorScheme('#FFD700', '#CCA300'),
    new ColorScheme('#2F8C4A', '#1F6337'),
    new ColorScheme('#00AEEF', '#0082B3'),
    new ColorScheme('#FF00FF', '#B300B3'),
    new ColorScheme('#FF8E56', '#FF7740'),
    new ColorScheme('#0000FF', '#000099'),
    new ColorScheme('#39B54A', '#2E9940'),
    new ColorScheme('#8560A8', '#704D9F'),
    new ColorScheme('#A0410D', '#8F2E09'),
    new ColorScheme('#E52B50', '#C41F3A'),
    new ColorScheme('#002F87', '#002266'),
    new ColorScheme('#C0A45D', '#9A8646'),
    new ColorScheme('#A60064', '#8E004D'),
    new ColorScheme('#7AEE3C', '#64C027'),
    new ColorScheme('#61279E', '#4B1F7A'),
    new ColorScheme('#FF4814', '#D23A0F'),
    new ColorScheme('#006648', '#005A3F'),
    new ColorScheme('#93B4D2', '#738CB2'),
    new ColorScheme('#800000', '#660000'),
    new ColorScheme('#94D600', '#78B300'),
    new ColorScheme('#E60896', '#B4077F'),
    new ColorScheme('#FF9D40', '#E68326'),
    new ColorScheme('#0096AA', '#007D8C'),
    new ColorScheme('#64513D', '#4B3E30'),
    new ColorScheme('#91D6AD', '#75B391'),
    new ColorScheme('#B9BF15', '#A6AC10'),
    new ColorScheme('#50026E', '#3B0155'),
    new ColorScheme('#7CA0C5', '#6484A1'),
    new ColorScheme('#939A91', '#787C82'),
    new ColorScheme('#FF1493', '#D60F78'),
    new ColorScheme('#6F4F47', '#593F39'),
  ];

  private static readonly fallbackColor: ColorScheme = new ColorScheme('#9E9E9E', '#757575');
  private static index: number = 0;
  private static userNameColorList: IUserColorModel[] = [];

  public static getColor(userName: string): ColorScheme {
    // Fallback for missing/empty user
    if (!userName || userName.trim() === '') {
      return {
        backgroundColor: this.fallbackColor.backgroundColor,
        borderColor: this.fallbackColor.borderColor,
      };
    }

    const user = this.userNameColorList.find((x) => x.user === userName);

    if (!user) {
      this.index++;
      if (this.index === this.userColorList.length) {
        this.index = 1;
      }

      this.userNameColorList.push({
        user: userName,
        backgorundColor: this.userColorList[this.index - 1].backgroundColor,
        borderColor: this.userColorList[this.index - 1].borderColor,
      });

      return {
        backgroundColor: this.userColorList[this.index - 1].backgroundColor,
        borderColor: this.userColorList[this.index - 1].borderColor,
      };
    }

    return { backgroundColor: user.backgorundColor, borderColor: user.borderColor };
  }
}
